import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_AuthorizedDrivers } from "../shared/data.service";
import { DriverImportRequest } from "../shared/DriverImportRequest";

@Component({
	selector: "app-import-authorized-driver",
	templateUrl: "./import-authorized-driver.component.html",
	styleUrls: ["./import-authorized-driver.component.css"],
})
export class ImportAuthorizedDriverComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private AuthorizedDriversService: DataService_AuthorizedDrivers
	) {}

	ngOnInit(): void {
		this.loadFormatOptions();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	LoadingOptions: any = true;
	IsProcessing: any = false;

	FormatOption: any;
	lstFormatOptions: any = [];

	ImportFile: any; //Data, ex. ImportFile.name
	ImportData: any = ""; //Base 64

	Deactivate: any = false;

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingOptions = true;

		var result = this.AuthorizedDriversService.DriverFormatSelectList();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				this.lstFormatOptions = response;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOption = next;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onSelectFile() {
		this.errorMessage = "";

		document.getElementById("ImportInput").click();
	}

	onImport() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		//No Data
		if (this.ImportData == "") {
			this.errorMessage = "Select a file to import";
			return;
		}

		//Bad Format
		if (String(this.ImportFile.type) != "text/plain" && String(this.ImportFile.type) != "text/csv") {
			this.errorMessage = "Invalid format";
			return;
		}

		this.IsProcessing = true;

		let parms: DriverImportRequest = {
			ImportDataBase64: this.ImportData,
			FormatOption: this.FormatOption.ID,
			Deactivate: this.Deactivate == true ? 1 : 0,
		};

		var result = this.AuthorizedDriversService.AuthorizedDriverImport(parms);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "import",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Successfully imported Authorized Drivers",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "import",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not import Authorized Drivers",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onClose() {
		this.errorMessage = "";

		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////

	onFileToImportChange(val) {
		// console.log("Import File Changed");
		// console.log(val);

		this.ImportFile = val.target.files[0];

		// console.log("Import File");
		// console.log(this.ImportFile);

		var fr = new FileReader();
		fr.readAsDataURL(this.ImportFile);

		fr.onload = () => {
			this.FinishLoadFile(fr.result);
		};
	}

	FinishLoadFile(f) {
		this.ImportData = f;
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingOptions == true || this.IsProcessing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
